import React, { useEffect, useState } from 'react'
import { RealEstateDataPageComponentData } from 'types'
import { Col, Container, Row } from 'react-bootstrap'
import Loader from '@components/loader/1'
import { useInView } from 'react-intersection-observer'

import Image from '@components/Image'
const Bio = (props: RealEstateDataPageComponentData) => {
  const { isDemo } = props
  const { title, subtitle, bioAnimation, items, pyConfig } = isDemo ? props : props

  const { ref, inView } = useInView({
    triggerOnce: false, // Cargar solo una vez cuando sea visible
  })

  return (
    <section
      ref={ref}
      id="bio"
      className={
        'bio-section' + (pyConfig ? ' p-y-config' : '') + (items?.length === 0 ? ' d-none' : '')
      }
    >
      <>
        <Container fluid>
          {title ? (
            <Col xs={12}>
              <h2 className="title text-center mb-4">{title}</h2>
            </Col>
          ) : null}
          {subtitle ? (
            <Col xs={12}>
              <p className="subtitle text-center pb-3 mb-5 mx-auto">{subtitle}</p>
            </Col>
          ) : null}
        </Container>
        {items && items?.length > 0
          ? items?.map((item, i) => (
              <div
                className={'bio-container' + (i > 0 ? ' bio-space' : '')}
                key={i}
              >
                <Row>
                  <Col
                    xs={12}
                    lg={7}
                    className={
                      (item?.align && item?.align === 'left'
                        ? 'order-1 order-lg-2 ps-0'
                        : 'order-1 pe-0') +
                      ' ' +
                      (bioAnimation && inView
                        ? item?.align && item?.align === 'left'
                          ? 'animate__animated animate__fadeInLeft'
                          : 'animate__animated animate__fadeInRight'
                        : '')
                    }
                  >
                    <Image
                      className="item-img no-border"
                      objectFit="cover"
                      alt={item?.title!}
                      image={item?.image_gatsby!}
                    />
                  </Col>
                  <Col
                    xs={12}
                    lg={5}
                    className={
                      'pl-lg-3 d-flex align-items-start flex-column' +
                      (item?.align && item?.align === 'left' ? ' order-1' : ' order-1 order-lg-2') +
                      ' ' +
                      (bioAnimation && inView
                        ? item?.align && item?.align === 'left'
                          ? 'animate__animated animate__fadeInLeft'
                          : 'animate__animated animate__fadeInRight'
                        : '')
                    }
                  >
                    <Container
                      fluid
                      className="p-lg-5 mt-lg-auto mt-5 mb-lg-auto mb-0"
                    >
                      <div className="d-lg-block title-wrapper pb-4 mb-4 text-center text-lg-start">
                        <h3 className="title mt-4">{item?.title}</h3>
                        <h5 className="subtitle fw-light text-uppercase">{item?.value}</h5>
                      </div>
                      {item?.paragraphs && item?.paragraphs?.length > 0
                        ? item?.paragraphs?.map((p, i) => (
                            <p
                              className="head-paragraphs er text-content text-center text-lg-start"
                              key={i}
                            >
                              {p}
                            </p>
                          ))
                        : null}
                      {item?.paragraph && item?.paragraph?.length > 0 ? (
                        <p
                          className="my-3 text-content text-center text-lg-start"
                          key={i}
                        >
                          {item?.paragraph}
                        </p>
                      ) : null}
                    </Container>
                  </Col>
                </Row>
              </div>
            ))
          : null}
      </>
    </section>
  )
}

export default Bio
